import { useEffect } from 'react';

import { useMst } from '@trader/store';

import { useHub } from './core/useHub';
import {
  EConnectionHub,
  EConnectionHubSubscriber,
  IMessageCustomerAccount,
} from './core/types';

export const useCustomerAccount = () => {
  const store = useMst();

  const idToken = store.auth.tokens.idToken;

  const { unsubscribe, subscribe } = useHub<IMessageCustomerAccount>({
    url: `${import.meta.env.VITE_SIGNALR_URL}/inboxes`,
    hub: EConnectionHub.Inboxes,
    subscriber: EConnectionHubSubscriber.CustomerAccount,
    onMessage: message => {
      store.user.runInAction(() => {
        store.user.profile.isRegistrationCompleted =
          message.isRegistrationCompleted;
      });
    },
    invokedName: 'OnCustomerAccount',
    subscriptionArgs: {},
  });

  useEffect(() => {
    if (store.auth.isAuth) {
      subscribe();
    }
    return () => {
      if (!store.auth.isAuth) {
        unsubscribe();
      }
    };
  }, [store.auth.isAuth, idToken]);
};
